var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "business-hours-picker" },
    [
      _vm._l(_vm.innerList, function (block, blockIndex) {
        return _c(
          "div",
          { key: blockIndex, staticClass: "business-hours-block" },
          [
            _c(
              "div",
              { staticClass: "block-header" },
              [
                _c("span", { staticClass: "block-title" }, [
                  _vm._v("营业时间" + _vm._s(blockIndex + 1)),
                ]),
                _vm._v(" "),
                _vm.innerList.length > 1
                  ? _c(
                      "el-button",
                      {
                        staticClass: "delete-block-btn",
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.removeBlock(blockIndex)
                          },
                        },
                      },
                      [_vm._v("\n        删除\n      ")]
                    )
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "field-group" }, [
              _c("div", { staticClass: "field-label" }, [_vm._v("星期范围")]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "week-range-row" },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "week-select",
                      attrs: { placeholder: "请选择" },
                      on: {
                        change: function ($event) {
                          return _vm.handleWeekStartChange(block, blockIndex)
                        },
                      },
                      model: {
                        value: block.weekStart,
                        callback: function ($$v) {
                          _vm.$set(block, "weekStart", $$v)
                        },
                        expression: "block.weekStart",
                      },
                    },
                    _vm._l(_vm.WEEK_OPTIONS, function (day) {
                      return _c("el-option", {
                        key: "start-" + blockIndex + "-" + day.value,
                        attrs: {
                          label: day.label,
                          value: day.value,
                          disabled: _vm.isWeekStartDisabled(
                            blockIndex,
                            day.value
                          ),
                        },
                      })
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "range-separator" }, [
                    _vm._v("至"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-select",
                    {
                      staticClass: "week-select",
                      attrs: { placeholder: "请选择" },
                      on: {
                        change: function ($event) {
                          return _vm.handleWeekEndChange(block, blockIndex)
                        },
                      },
                      model: {
                        value: block.weekEnd,
                        callback: function ($$v) {
                          _vm.$set(block, "weekEnd", $$v)
                        },
                        expression: "block.weekEnd",
                      },
                    },
                    _vm._l(_vm.WEEK_OPTIONS, function (day) {
                      return _c("el-option", {
                        key: "end-" + blockIndex + "-" + day.value,
                        attrs: {
                          label: day.label,
                          value: day.value,
                          disabled: _vm.isWeekEndDisabled(
                            blockIndex,
                            block.weekStart,
                            day.value
                          ),
                        },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "field-group" },
              [
                _c("div", { staticClass: "field-label" }, [_vm._v("营业时间")]),
                _vm._v(" "),
                _vm._l(block.timeSlots, function (slot, slotIndex) {
                  return _c(
                    "div",
                    { key: slotIndex, staticClass: "time-slot-row" },
                    [
                      _c("el-time-picker", {
                        staticClass: "time-range-picker",
                        attrs: {
                          "is-range": "",
                          "range-separator": "-",
                          "start-placeholder": "开始时间",
                          "end-placeholder": "结束时间",
                          format: "HH:mm",
                          "value-format": "HH:mm",
                          "picker-options": _vm.timePickerOptions,
                        },
                        on: {
                          change: function ($event) {
                            return _vm.handleTimeChange(block, slotIndex)
                          },
                        },
                        model: {
                          value: slot.timeRange,
                          callback: function ($$v) {
                            _vm.$set(slot, "timeRange", $$v)
                          },
                          expression: "slot.timeRange",
                        },
                      }),
                      _vm._v(" "),
                      slotIndex === block.timeSlots.length - 1 &&
                      block.timeSlots.length < _vm.MAX_TIME_SLOTS
                        ? _c("el-button", {
                            staticClass: "slot-action-btn",
                            attrs: {
                              type: "primary",
                              icon: "el-icon-plus",
                              circle: "",
                              size: "mini",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.addTimeSlot(blockIndex)
                              },
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      block.timeSlots.length > 1
                        ? _c("el-button", {
                            staticClass: "slot-action-btn",
                            attrs: {
                              type: "danger",
                              icon: "el-icon-minus",
                              circle: "",
                              size: "mini",
                              plain: "",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.removeTimeSlot(blockIndex, slotIndex)
                              },
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  )
                }),
              ],
              2
            ),
            _vm._v(" "),
            _c("div", { staticClass: "field-group remark-field-group" }, [
              _c(
                "div",
                { staticClass: "remark-row" },
                [
                  _c(
                    "div",
                    { staticClass: "remark-label" },
                    [
                      _c(
                        "el-tooltip",
                        {
                          attrs: {
                            content:
                              "备注后将展示在移动端店铺信息的营业时间之后",
                            placement: "top",
                          },
                        },
                        [
                          _c("i", {
                            staticClass: "el-icon-question remark-help-icon",
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _c("span", [_vm._v("信息备注：")]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("el-input", {
                    staticClass: "remark-input",
                    attrs: {
                      placeholder: "请输入",
                      maxlength: _vm.MAX_INFO_REMARK_LENGTH,
                      "show-word-limit": "",
                    },
                    on: { input: _vm.emitChange },
                    model: {
                      value: block.infoRemark,
                      callback: function ($$v) {
                        _vm.$set(block, "infoRemark", $$v)
                      },
                      expression: "block.infoRemark",
                    },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "example-text" }, [
              _vm._v("示例：" + _vm._s(_vm.getBlockPreview(block))),
            ]),
          ]
        )
      }),
      _vm._v(" "),
      _vm.canAddBlock
        ? _c(
            "el-button",
            {
              staticClass: "add-block-btn",
              attrs: { type: "primary", size: "small" },
              on: { click: _vm.addBlock },
            },
            [_vm._v("\n    新增营业时间\n  ")]
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }